import React from "react";
import {
    colorWithAlpha,
    NavigationMenuComponent,
    NavigationMenuItem,
    NavigationMenuItemType,
} from "@pledger/frontend-commons";
import {NavigationMenuState} from "./NavigationMenuReducers";
import {ShowPageActions} from "../../../ui/app/Pages/ShowPageActions";
import {AppActions} from "../../../ui/app/AppActions";
import {NavigationMenuActions} from "./NavigationMenuActions";
import {AppComponentContext} from "../../../ui/app/AppComponentContext";
import {BUILD_NUMBER} from "../../../buildNumber";


export enum NavigationMenuItemId {
    NONE = 'NONE',
    ACCUEIL = 'ACCUEIL',
    VENTES = 'VENTES',
    NOUVEAU_DOSSIER = 'NOUVEAU_DOSSIER',
    SUIVI_VENTE = 'SUIVI_VENTE',
    CONTACT = 'CONTACT',
    RETOUR_B2C = 'RETOUR_B2C'
}


const navigationMenuContent : NavigationMenuItem<NavigationMenuItemId>[]  = [
    {identifier: NavigationMenuItemId.ACCUEIL, type: NavigationMenuItemType.MAIN_ITEM, title: 'Accueil', iconURL: 'images/white-home-icon.svg', action: ShowPageActions.SHOW_HOME_ACTION.build(false)},
    {type: NavigationMenuItemType.SEPARATOR,userScopes:['DISTRIBUTOR_PARTNER']},
    {identifier: NavigationMenuItemId.VENTES, type: NavigationMenuItemType.MAIN_ITEM, title: 'Ventes', iconURL: 'images/file-add-icon.svg', action: ShowPageActions.SHOW_CREATE_SOUSCRIPTION_ACTION.build(false),userScopes:['DISTRIBUTOR_PARTNER']},
    {identifier: NavigationMenuItemId.NOUVEAU_DOSSIER, type: NavigationMenuItemType.SUB_ITEM, title: 'Nouveau dossier', action: ShowPageActions.SHOW_CREATE_SOUSCRIPTION_ACTION.build(false), parentItemId: NavigationMenuItemId.VENTES,userScopes:['DISTRIBUTOR_PARTNER']},
    {identifier: NavigationMenuItemId.SUIVI_VENTE, type: NavigationMenuItemType.SUB_ITEM, title: 'Suivi', action: ShowPageActions.SHOW_SUIVI_VENTES_ACTION.build(false), parentItemId: NavigationMenuItemId.SUIVI_VENTE,userScopes:['DISTRIBUTOR_PARTNER']},
    {type: NavigationMenuItemType.SEPARATOR},
    {identifier: NavigationMenuItemId.CONTACT, type: NavigationMenuItemType.MAIN_ITEM, title: 'Contact', iconURL: 'images/white-contact-icon.svg', action: ShowPageActions.SHOW_CONTACT_ACTION.build(false)},
    {type: NavigationMenuItemType.SEPARATOR},
    {identifier: NavigationMenuItemId.RETOUR_B2C, type: NavigationMenuItemType.MAIN_ITEM, title: 'Retour B2C', iconURL: 'images/full-white-PLogo.svg', action: NavigationMenuActions.NAVIGATION_MENU_RETOUR_B2C_ITEM_ACTION.build()},

];

interface DistributorNavigationMenuComponentProps {
    context: AppComponentContext;
    state:NavigationMenuState;
}



export class DistributorNavigationMenuComponent extends React.Component<DistributorNavigationMenuComponentProps> {

    render() {
        const state = this.props.state;
        const context = this.props.context;
        const customColors = context.appContext.customColors;
        // const isPhone = context.appContext.isPhone;


        const onClickMenuItemAction = (item: NavigationMenuItem<NavigationMenuItemId>) => {
            if (item.action !== undefined && item.identifier !== undefined) {
                let itemIdentifier: NavigationMenuItemId;
                switch (item.identifier) {
                    case NavigationMenuItemId.VENTES:
                        itemIdentifier = NavigationMenuItemId.NOUVEAU_DOSSIER;
                        break;
                    case NavigationMenuItemId.ACCUEIL:
                    case NavigationMenuItemId.NOUVEAU_DOSSIER:
                    case NavigationMenuItemId.SUIVI_VENTE:
                    case NavigationMenuItemId.CONTACT:
                    case NavigationMenuItemId.RETOUR_B2C:
                        itemIdentifier = item.identifier;
                        break;
                    default:
                        itemIdentifier = item.identifier;
                }
                const action = NavigationMenuActions.NAVIGATION_MENU_SELECT_MENU_ITEM_ACTION.build(itemIdentifier, item.action);
                context.dispatch(action);
            }
        }

        const deselectAllMenuItems = () => {
            context.dispatch(NavigationMenuActions.NAVIGATION_MENU_SELECT_MENU_ITEM_ACTION.build(NavigationMenuItemId.NONE, AppActions.EMPTY_ACTION.build()));
        }

         return (
            <NavigationMenuComponent<NavigationMenuItemId>
                context={context}
                displayUserMenu={state.displayUserMenu}
                selectedMenuItemId={state.selectedMenuItemId}
                navigationMenuContent={navigationMenuContent}
                disconnectActionBuilder={AppActions.DISCONNECT_ACTION.build}
                showAccountActionBuilder={() => ShowPageActions.SHOW_ACCOUNT_ACTION.build(false)}
                showUserMenuActionBuilder={NavigationMenuActions.NAVIGATION_MENU_DISPLAY_USER_MENU_ACTION.build}
                onConnectActionBuilder={() => ShowPageActions.SHOW_LOGIN_ACTION.build(false)}
                onClickMenuItem={onClickMenuItemAction}
                deselectAllMenuItems={deselectAllMenuItems}
                userScopes={context.appContext.userScopes}
                userFirstName={context.appContext.userFirstName}
                userLastName={context.appContext.userLastName}
                userPartnerName={context.appContext.userPartnerName}
                color={customColors.PLEDGER_GREEN_COLOR}
                backgroundColor={`linear-gradient(168.07deg, ${customColors.PLEDGER_START_GRADIENT_COLOR} 0.65%, ${customColors.PLEDGER_END_GRADIENT_COLOR} 91.28%)`}
                shadowColor={colorWithAlpha(customColors.PLEDGER_GREEN_COLOR,0.2)}
                signoutColor={customColors.PLEDGER_START_GRADIENT_COLOR}
                buildNumber={BUILD_NUMBER}/>
        );
    }
}
